export const createExpandedStyle = (innerHeight: number) => ({ height: `${innerHeight}px` });
